<template>
    <v-container>
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
            <p class="headline">Apply Ticket:</p>
            <choose-date v-model="date" label="Date"/>
            <v-textarea v-model="reason" label="Reason"></v-textarea>
            <v-btn color="primary" @click="submit">Submit</v-btn>
        </v-form>
    </v-container>

</template>
<script>
    import ChooseDate from "@/components/wasilni/input/ChooseDate";

    export default {
        name: "JustificationTicketForm",
        components: {ChooseDate},
        data() {
            return {
                dialog: false,
                snackbar: false,
                message: "",
                valid: true,
                lazy: false,
                loading: false,
                requiredRules: [(v) => !!v || "الحقل مطلوب"],
                model: null,
                reason: null,
                date: null
            }
        },
        methods: {
            submit() {
                this.loading = true;
                this.axios.post(this.api.ACTIONS.TICKETS, {
                    ticket_type_id: this.model.ticket_type_id,
                    last_question_id: this.model.last_question_id,
                    answers: {
                        [this.model.date]: this.date,
                        [this.model.reason]: this.reason
                    }
                })
                    .then(res => {
                        window.getApp.$emit("SHOW_TOAST", "Your ticket was saved", "green");
                    })
                    .catch(err => {
                        window.getApp.$emit("SHOW_TOAST", err, "red");
                        console.log(err)
                    })
                    .finally(() => {
                        this.loading = false;
                        this.$emit('close-dialog');
                    });
            }
        },
        mounted() {
            this.axios.get('justify_ticket_data')
                .then(res => {
                    this.model = res.data.data;
                }).catch(err => {
                console.log(err)
            });

        }
    }
</script>

<style scoped>

</style>
